(() => {
  const dialog = document.getElementById('bl-cart-dialog');
  if (!dialog) return;
  document.documentElement.classList.add('bl-cart-live');
  const cartSurfaces = () => Array.from(document.querySelectorAll('[data-bl-cart-section]'));
  let refreshing = null;
  let saving = null;
  let pendingForm = null;
  let updateTimer = null;
  let dirty = false;
  let updateFailed = false;
  function feedback(message) {
    document.querySelectorAll('[data-bl-cart-feedback]').forEach(el => { el.textContent = message; });
  }
  function syncControls() {
    cartSurfaces().forEach(surface => {
      surface.setAttribute('aria-busy', String(Boolean(saving)));
      surface.querySelectorAll('[name="updates[]"], [data-bl-quantity-action], [name="update"]').forEach(el => { el.disabled = Boolean(saving); });
      surface.querySelectorAll('[name="checkout"]').forEach(el => { el.disabled = dirty || Boolean(saving); });
      surface.querySelectorAll('[name="update"]').forEach(el => { el.toggleAttribute('data-bl-retry', updateFailed); });
    });
  }
  async function refreshCart() {
    if (refreshing) return refreshing;
    refreshing = (async () => {
      const rendered = await Promise.all(cartSurfaces().map(async surface => {
        const url = new URL(dialog.dataset.cartUrl, location.origin);
        url.searchParams.set('section_id', surface.dataset.blCartSection);
        url.searchParams.set('_', Date.now());
        const response = await fetch(url, {headers:{Accept:'text/html'},cache:'no-store'});
        if (!response.ok) throw new Error('Cart unavailable');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const content = doc.querySelector('[data-bl-cart-body]');
        if (!content) throw new Error('Cart unavailable');
        return {surface, content};
      }));
      rendered.forEach(({surface, content}) => surface.querySelector('[data-bl-cart-body]').replaceChildren(...content.childNodes));
      syncControls();
      const cartUrl = new URL(dialog.dataset.cartUrl.replace(/\/$/,'')+'.js',location.origin);
      const cartResponse = await fetch(cartUrl,{headers:{Accept:'application/json'},cache:'no-store'});
      if (cartResponse.ok) { const cart=await cartResponse.json();document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count); }
    })().finally(()=>{refreshing=null;});
    return refreshing;
  }
  function validQuantity(input) {
    return input.value !== '' && Number.isInteger(Number(input.value)) && Number(input.value) >= 0;
  }
  function scheduleUpdate(form, immediate = false) {
    if (saving) return;
    clearTimeout(updateTimer);
    pendingForm = form;
    dirty = true;
    updateFailed = false;
    feedback(dialog.dataset.updating);
    syncControls();
    if (Array.from(form.querySelectorAll('[name="updates[]"]')).every(validQuantity)) {
      updateTimer = setTimeout(() => saveCart(form), immediate ? 0 : 450);
    }
  }
  async function saveCart(form) {
    if (saving) return saving;
    clearTimeout(updateTimer);
    if (!form || !Array.from(form.querySelectorAll('[name="updates[]"]')).every(validQuantity)) return false;
    const body = new FormData(form);
    const surfaceId = form.closest('[data-bl-cart-section]').dataset.blCartSection;
    const focused = document.activeElement;
    const focusedVariant = focused?.closest('.bl-cart-stepper')?.querySelector('input')?.dataset.blVariantId;
    const focusedAction = focused?.dataset.blQuantityAction;
    dirty = true;
    updateFailed = false;
    feedback(dialog.dataset.updating);
    saving = (async () => {
      // Finish any earlier read before mutating, so stale prices cannot replace the new cart.
      if (refreshing) await refreshing.catch(() => {});
      const url = new URL(dialog.dataset.cartUrl.replace(/\/$/,'')+'/update.js',location.origin);
      const response = await fetch(url,{method:'POST',body,headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Cart update failed');
      await refreshCart();
      dirty = false;
      pendingForm = null;
      feedback(dialog.dataset.updated);
      return true;
    })().catch(() => {
      updateFailed = true;
      feedback(dialog.dataset.updateError);
      return false;
    }).finally(() => {
      saving = null;
      syncControls();
      const surface = cartSurfaces().find(el => el.dataset.blCartSection === surfaceId);
      const input = Array.from(surface?.querySelectorAll('[name="updates[]"]') || []).find(el => el.dataset.blVariantId === focusedVariant);
      const target = focusedAction ? input?.closest('.bl-cart-stepper').querySelector(`[data-bl-quantity-action="${focusedAction}"]`) : input;
      target?.focus({preventScroll:true});
    });
    syncControls();
    return saving;
  }
  async function openCart() {
    try {if (saving) await saving;else if (dirty && pendingForm) await saveCart(pendingForm);await refreshCart();if(!dialog.open)dialog.showModal();}
    catch {location.assign(dialog.dataset.cartUrl);}
  }
  const giftCards = Array.from(document.querySelectorAll('#product-grid [data-bl-category]'));
  const moreGifts = document.querySelector('[data-bl-show-more]');
  const giftCount = document.querySelector('[data-bl-gift-count]');
  let giftFilter = 'all';
  let giftLimit = 12;
  function renderGifts() {
    const matches = giftCards.filter(card => giftFilter === 'all' || card.dataset.blCategory === giftFilter);
    const visible = new Set(matches.slice(0, giftLimit));
    giftCards.forEach(card => { card.hidden = !visible.has(card); });
    document.querySelectorAll('[data-bl-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.blFilter === giftFilter)));
    if (moreGifts) moreGifts.hidden = matches.length <= giftLimit;
    if (giftCount) giftCount.textContent = giftCount.dataset.template.replace('__SHOWN__', Math.min(matches.length, giftLimit)).replace('__TOTAL__', matches.length);
    return matches;
  }
  renderGifts();
  document.addEventListener('click',event=>{
    const open=event.target.closest('[data-bl-cart-open]');
    if(open){event.preventDefault();openCart();}
    if(event.target.closest('[data-bl-cart-close]'))dialog.close();
    const quantityButton = event.target.closest('[data-bl-quantity-action]');
    if (quantityButton && !saving) {
      const input = quantityButton.closest('.bl-cart-stepper').querySelector('input');
      input.value = Math.max(0, Number(input.value || input.defaultValue) + Number(quantityButton.dataset.blQuantityAction));
      scheduleUpdate(input.form);
    }
    const remove = event.target.closest('[data-bl-remove]');
    if (remove) {
      event.preventDefault();
      if (!saving) {
        const input = remove.closest('.bl-cart-quantity').querySelector('input');
        input.value = 0;
        scheduleUpdate(input.form, true);
      }
    }
    const filter=event.target.closest('[data-bl-filter]');
    const guide=event.target.closest('[data-bl-guide]');
    if (filter || guide) {
      giftFilter = filter ? filter.dataset.blFilter : guide.dataset.blGuide;
      giftLimit = 12;
      renderGifts();
      if (guide) document.getElementById('gifts')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
    if (event.target.closest('[data-bl-show-more]')) {
      const previousLimit = giftLimit;
      giftLimit += 12;
      const matches = renderGifts();
      matches[previousLimit]?.querySelector('h3 a')?.focus();
    }
  });
  dialog.addEventListener('click',event=>{if(event.target===dialog&&event.clientX<dialog.getBoundingClientRect().left)dialog.close();});
  document.addEventListener('boxyloot:cart-added',openCart);
  document.addEventListener('input', event => {
    if (event.target.matches('[data-bl-cart-form] [name="updates[]"]')) scheduleUpdate(event.target.form);
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-bl-cart-form] [name="updates[]"]') && !saving) {
      if (!validQuantity(input)) input.value = input.defaultValue;
      scheduleUpdate(input.form, true);
    }
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement))return;
    if(form.matches('[data-bl-cart-form]')){
      if (event.submitter?.name !== 'checkout' || dirty || saving) {
        event.preventDefault();
        await saveCart(form);
      }
      return;
    }
    if(!form.matches('[data-bl-quick-add]'))return;
    event.preventDefault();const button=form.querySelector('button');if(button.disabled)return;const old=button.textContent;button.disabled=true;button.textContent=dialog.dataset.adding;
    try{
      const url=new URL(form.action,location.origin);url.pathname=url.pathname.replace(/\/$/,'')+'.js';
      const response=await fetch(url,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      if(!response.ok){const error=await response.json().catch(()=>null);throw new Error(error?.description||dialog.dataset.error);}
      await openCart();
    }catch(error){let status=form.querySelector('[role="alert"]');if(!status){status=document.createElement('p');status.setAttribute('role','alert');status.className='bl-cart-status';form.append(status);}status.textContent=error.message||dialog.dataset.uncertain;}
    finally{button.disabled=false;button.textContent=old;}
  });
})();
